import http from '../webhook/httpconfig'
import AppError from '../errors/app-errors'
import { generateHeaders } from '../webhook/webhook'
import { cancelHTTPRequests } from '@/services/utils'
//TODO: Update url and make a generic base url with api as prefix.

async function login(authToken, payload = {}) {
    try {
        const result = await http.request({
            method: 'post',
            url: '/api/login', 
            data: payload,
            headers: generateHeaders([{key: 'x-auth-token', value: authToken}]),
            cancelToken: cancelHTTPRequests()
        })
        return result
    } catch (error) {
        throw new AppError({
            name: 'Authentication - LOGIN',
            message: 'Could not login user',
            error
        })
    }
}

async function logout(payload = {}) {
    try {
        const result = await http.request({
            method: 'post',
            url: '/api/logout',
            data: payload,
            headers: generateHeaders(),
            cancelToken: cancelHTTPRequests()
        })
        return result
    } catch (error) {
        throw new AppError({
            name: 'Authentication - LOGIN',
            message: 'Could not login user',
            error
        })
    }
}

async function updateAgentDeskConnectionStatus(payload = {}) {
    try {
        const result = await http.request({
            method: 'post',
            url: '/api/updateAgentDeskConnectionStatus',
            data: payload,
            headers: generateHeaders(),
            cancelToken: cancelHTTPRequests()
        })
        return result
    } catch (error) {
        throw new AppError({
            name: 'Authentication - UPDATING AGENT DESK CONNECTION STATUS',
            message: 'Could not update agent desk connection status',
            error
        })
    }
}

async function getAgentDeskConnectionStatus(payload = {}) {
    try {
        const result = await http.request({
            method: 'post',
            url: '/api/getAgentDeskConnectionStatus',
            data: payload,
            headers: generateHeaders(),
            cancelToken: cancelHTTPRequests()
        })
        return result
    } catch (error) {
        throw new AppError({
            name: 'Authentication - GET AGENT DESK CONNECTION STATUS',
            message: 'Could not get agent desk connection status',
            error
        })
    }
}

export {
    login,
    logout,
    updateAgentDeskConnectionStatus,
    getAgentDeskConnectionStatus
}